import { TemplateStatusType, WorkOrderStatusType } from "../api/models";

const DEFAULT_PRINT_STRING = "---";

/** Prints a readable date string */
export function toDateString(v?: Date) {
  if (v === undefined) {
    return DEFAULT_PRINT_STRING;
  }

  const vDate = new Date(v);
  return vDate.toLocaleDateString();
}

/** Prints a readable date-time string */
export function toDateTimeString(v?: Date) {
  if (v === undefined) {
    return DEFAULT_PRINT_STRING;
  }

  const vDate = new Date(v);
  return vDate.toLocaleDateString() + " " + vDate.toLocaleTimeString();
}

export function toPrintableTemplateStatus(status: TemplateStatusType) {
  switch (status) {
    case TemplateStatusType.PendingAssets:
      return "Pending Assets";
    default:
      return status;
  }
}

export function toTemplateStatusColor(status: TemplateStatusType): string {
  switch (status) {
    case TemplateStatusType.PendingAssets:
      return "orange";
    case TemplateStatusType.Ready:
      return "green";
    default:
      return "default";
  }
}

export function toDependentFileTypeColor(isTemplateAsset: boolean): string {
  return isTemplateAsset ? "gold" : "blue";
}

export function toUploadStatusColor(uploaded: boolean): string {
  return uploaded ? "green" : "orange";
}

export function toTemplateDetailItemTypeColor(type: "File" | "File Sequence" | "CSV Parameter" | "Smart Folder Parameter"): string {
  switch (type) {
    case "File":
      return "gold";
    case "File Sequence":
      return "gold";
    case "CSV Parameter":
      return "blue";
    case "Smart Folder Parameter":
      return "blue";
  }
}

export function toPrintableWorkOrderStatus(status: WorkOrderStatusType) {
  switch (status) {
    case WorkOrderStatusType.PendingDynamicAssets:
      return "Pending Dynamic Assets";
    case WorkOrderStatusType.PendingParameters:
      return "Pending Parameters";
    case WorkOrderStatusType.PreparingResults:
      return "Preparing Results";
    case WorkOrderStatusType.QueuedForProcessing:
      return "Queued for Processing";
    case WorkOrderStatusType.QueuedForRendering:
      return "Queued for Rendering";
    default:
      return status;
  }
}

export function toWorkOrderStatusColor(status: WorkOrderStatusType): string {
  switch (status) {
    case WorkOrderStatusType.Failed:
      return "red";
    case WorkOrderStatusType.Done:
      return "green";
    case WorkOrderStatusType.PendingParameters:
    case WorkOrderStatusType.PendingDynamicAssets:
      return "orange";
    case WorkOrderStatusType.QueuedForProcessing:
    case WorkOrderStatusType.QueuedForRendering:
      return "gold";
    case WorkOrderStatusType.Rendering:
      return "blue";
    case WorkOrderStatusType.PreparingResults:
      return "purple";
    case WorkOrderStatusType.Archived:
    default:
      return "default";
  }
}

/** Prompts a file download by appending an anchor tag to the main HTML document. */
export function downloadFile(file: string, csv: string) {
  const link = document.createElement('a');
  link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv);
  link.setAttribute('download', file);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
}
